// Dashboard.jsx
import { Row, Col } from "antd";
import TaskCount from 'components/Dashboard/TaskCount';
import Resource from '../Resources/Resources';
import useIsMobileHooks from "hooks/useIsMobileHooks";
import useTopbarTitleHooks from "hooks/useTopbarTitleHooks";

export default function Dashboard() {
    useTopbarTitleHooks("Home");
    const isMobile = useIsMobileHooks();

    return (
        <div className='dashboard-container'>
            {/* Baris pertama: Task List di pojok kanan */}
            {/* <div
                style={{
                    position: 'sticky',
                    top: 8,                // offset dari atas viewport
                    zIndex: 10,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '100%'
                }}
            >
                <TaskCount />
            </div> */}

            {/* Baris berikutnya untuk summary card / komponen lain */}
            <Row gutter={[16, 16]}>
                <Resource />
            </Row>
        </div>
    )
}
